import React from 'react';
import BrandLogo from './BrandLogo';
import './ContentCreationPage.css';

const ccpImages = {
  hero: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/content-creation-page/1.png',
  heritage: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/content-creation-page/Heritage.png',
  kinetic: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/content-creation-page/Kinetic%20Energy.png',
  silicon: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/content-creation-page/Silicon%20%26%20Soul.png',
};

const marqueeItems = [
  'Visual Strategy',
  'Content Production',
  'Paid Acquisition',
  'Organic Marketing',
  'Creative Execution',
  'Social-First Strategy',
  'Community Building',
];

const scalingCards = [
  {
    id: '01',
    title: 'Creative Strategy',
    description:
      'Build concepts and campaign systems that align visual identity, brand memory, and business outcomes.',
  },
  {
    id: '02',
    title: 'Over-Improvised Content',
    description:
      'Transform rough ideas into high-impact creative assets while preserving speed, clarity, and consistency.',
  },
  {
    id: '03',
    title: 'Growth Marketing',
    description:
      'Use audience-led narratives and iterative testing to improve CTR, retention, and campaign performance.',
  },
  {
    id: '04',
    title: 'Talent Partnership',
    description:
      'Coordinate creators and production teams to deliver reliable execution across every active campaign.',
  },
];

const workCards = [
  {
    title: 'The Heritage Project',
    description:
      'Reimagining a 100-year old fashion house for modern digital storytelling and global relevance.',
    tag: 'CAMPAIGN . STORY . HERITAGE',
    image: ccpImages.heritage,
  },
  {
    title: 'Kinetic Energy',
    description:
      'A high-impact brand campaign for a growing activewear brand that drove momentum and visibility.',
    tag: 'BRAND . SOCIAL . PERFORMANCE',
    image: ccpImages.kinetic,
  },
  {
    title: 'Silicon of Soul',
    description:
      'Humanizing an HR-tech platform through playful storytelling and trust-driven communication.',
    tag: 'NARRATIVE . TECH . INNOVATION',
    image: ccpImages.silicon,
  },
];

const clientCards = [
  {
    quote:
      'BeyonDigital took our brand from invisible to indispensable in record time; our lead generation has not slowed down since. They are the strategic powerhouse every growing company needs in their corner.',
    name: 'Marcus Thorne',
    role: 'CEO, Lumina Crest Systems',
  },
  {
    quote:
      "BeyonDigital handles our content with a consistent, professional touch that aligns perfectly with our brand. It's a relief to have a reliable partner who delivers high-quality work on schedule without any oversight.",
    name: 'Thomas Reed',
    role: 'CEO, Ardent Logistics',
  },
  {
    quote:
      'Since we started working with BeyonDigital, our social media presence has become much more organized and polished. Their team produces clear, effective content that has helped us maintain a steady connection with our audience.',
    name: 'Vimlesh Chaurasia',
    role: 'CEO & Co-Founder, Risiko LLP',
  },
];

export default function ContentCreationPage() {
  return (
    <div className="ccp-page">
      <nav className="ccp-nav">
        <BrandLogo className="ccp-nav__logo" size="nav" />
        <ul className="ccp-nav__links">
          <li>
            <a href="#work">Styles</a>
          </li>
          <li>
            <a href="#services">Services</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
        </ul>
        <a href="#contact" className="ccp-nav__cta">
          Contact
        </a>
      </nav>

      <section className="ccp-hero">
        <div className="ccp-hero__visual">
          <img
            src={ccpImages.hero}
            alt="Content creation hero"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div className="ccp-hero__content">
          <p className="ccp-hero__eyebrow">Est. 2026 - London</p>
          <h1>
            Architecting
            <br />
            <em>the New</em>
            <br />
            Digital Era
          </h1>
          <p>
            We shape high-performance visual storytelling with a strategic precision built for
            brands that want to lead, not just trend.
          </p>
          <div className="ccp-hero__actions">
            <a href="#work" className="ccp-btn ccp-btn--dark">
              Explore Content Styles
            </a>
            <a href="#about" className="ccp-btn ccp-btn--ghost">
              Our Story ↗
            </a>
          </div>
          <div className="ccp-proof">
            <div>
              <strong>42+</strong>
              <span>Clients Scaled</span>
            </div>
            <div>
              <strong>5,500K+</strong>
              <span>Revenue</span>
            </div>
            <div>
              <strong>43%</strong>
              <span>Revenue Growth</span>
            </div>
          </div>
        </div>
      </section>

      <section className="ccp-marquee">
        <div className="ccp-marquee__track">
          {[...marqueeItems, ...marqueeItems].map((item, index) => (
            <React.Fragment key={`${item}-${index}`}>
              <span>{item}</span>
              <span className="ccp-marquee__dot">·</span>
            </React.Fragment>
          ))}
        </div>
      </section>

      <section className="ccp-section" id="services">
        <header className="ccp-section__header">
          <p className="ccp-section__tag">Expertise In</p>
          <h2>
            Scalling
            <br />
            <em>every brand</em>
          </h2>
        </header>
        <div className="ccp-grid ccp-grid--services">
          {scalingCards.map((card) => (
            <article className="ccp-service-card" key={card.title}>
              <p className="ccp-service-card__num">{card.id}</p>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="ccp-section" id="work">
        <header className="ccp-section__header ccp-section__header--showcase">
          <p className="ccp-section__tag">Styles We</p>
          <h2>
            Work with
            <br />
            <em>That speaks for themselves.</em>
          </h2>
        </header>
        <div className="ccp-grid ccp-grid--showcase">
          {workCards.map((item) => (
            <article className="ccp-showcase-card" key={item.title}>
              <div className="ccp-showcase-card__image">
                <img
                  src={item.image}
                  alt={item.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className="ccp-showcase-card__body">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <span>{item.tag}</span>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="ccp-section" id="about">
        <header className="ccp-section__header ccp-section__header--clients">
          <p className="ccp-section__tag">A Word</p>
          <h2>
            From our
            <br />
            <em>Beloved Clients</em>
          </h2>
        </header>
        <div className="ccp-grid ccp-grid--clients">
          {clientCards.map((item) => (
            <blockquote className="ccp-client-card" key={item.name}>
              <span className="ccp-client-card__mark">"</span>
              <p>{item.quote}</p>
              <cite>
                <strong>{item.name}</strong>
                <span>{item.role}</span>
              </cite>
            </blockquote>
          ))}
        </div>
      </section>

      <section className="ccp-cta" id="contact">
        <div className="ccp-cta__inner">
          <h2>
            Ready to redefine
            <br />
            <em>your digital presence?</em>
          </h2>
          <a href="mailto:sdevarsh54@beyondigital.co.uk" className="ccp-btn ccp-btn--dark">
            Start a conversation
          </a>
        </div>
      </section>

      <footer className="ccp-footer">
        <div className="ccp-footer__top">
          <div className="ccp-footer__brand">
            <BrandLogo size="footer" asLink={false} variant="dark" />
            <p>High-end social media marketing for brands that want to lead.</p>
          </div>
          <div className="ccp-footer__links">
            <div>
              <h4>Agency</h4>
              <a href="/">About</a>
              <a href="/">Work</a>
              <a href="/">Careers</a>
            </div>
            <div>
              <h4>Services</h4>
              <a href="/">Strategy</a>
              <a href="/">Content</a>
              <a href="/">Paid Social</a>
            </div>
            <div>
              <h4>Connect</h4>
              <a href="https://www.instagram.com/beyondigital.co/">Instagram</a>
              <a href="/">LinkedIn</a>
              <a href="/">Twitter/X</a>
            </div>
          </div>
        </div>
        <div className="ccp-footer__bottom">London - India - Dubai</div>
      </footer>
    </div>
  );
}
